<template>
  <div class="additional-field-row__actions">
    <sButton
      data-qa="btn-order-minus"
      :disabled="!sortUp"
      icon="long-arrow"
      small
      type="text"
      @click.stop="$emit('changeOrder', 1)"/>
    <sButton
      data-qa="btn-edit-field"
      :disabled="!sortDown"
      icon="long-arrow"
      :icon-class="'s-svg-icon-rotate-180'"
      small
      type="text"
      @click.stop="$emit('changeOrder', -1)"/>
    <sPopover
      :disabled="canEdit"
      trigger="hover"
      width="200">
      <div class="text-left px-3 py-3">
        {{ $t('AdditionalFields.BlockEdit') }}
      </div>
      <div
        slot="reference">
        <sButton
          data-qa="btn-order-plus"
          :disabled="!canEdit"
          icon="edit"
          small
          type="text"
          @click.stop="canEdit ? $emit('editField', item) : null"/>
      </div>
    </sPopover>
    <sButton
      data-qa="btn-delete-field"
      :disabled="!canDelete"
      icon="delete"
      small
      type="text"
      @click.stop="$emit('deleteField', item)"/>
  </div>
</template>
<script>
export default {
  name: 'additionalBlockActions',
  props: {
    item: {
      type: Object
    },
    sortUp: {
      type: Boolean
    },
    sortDown: {
      type: Boolean
    },
    canDelete: {
      type: Boolean
    },
    canEdit: {
      type: Boolean
    },
  },
}
</script>
<style scoped>
.additional-field-row__actions {
  display: flex;
}
</style>
